import React from "react";
import { useModalCaseCancelHook } from "./modal-case-cancel-hooks";

type ContextModalCaseCancel = ReturnType<typeof useModalCaseCancelHook>;
export const ModalCaseCancelContext =
  React.createContext<ContextModalCaseCancel | null>(null);

export function useContextModalCaseCancel() {
  const context = React.useContext(ModalCaseCancelContext);

  if (!context) {
    throw new Error(
      "useContextModalCaseCancel must be used within a ContextModalCaseCancelProvider",
    );
  }

  return context;
}
